import React, { useEffect, useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import Menu from '../../components/sturtural/Menu';
import { Dropdown } from 'primereact/dropdown'

let arr = [
    { Curp: 'DUGJ960116em0', Nombre: 'Javier Duarte Gonzalez', Grado: '2°', Grupo: '1', estatus: 'entregados' },
    { Curp: 'DUGJ960116em1', Nombre: 'Ernesto De los reyes Lopez', Grado: '2°', Grupo: '1', estatus: 'pendiente' },
    { Curp: 'DUGJ960116em2', Nombre: 'Pablo Daniels Enrique', Grado: '1°', Grupo: '1', estatus: 'entregados' },
    { Curp: 'DUGJ960116em3', Nombre: 'Alfredo Adame Parra', Grado: '1°', Grupo: '2', estatus: 'entregados' },
    { Curp: 'DUGJ960116em4', Nombre: 'Adan Gonzalez fuentes', Grado: '1°', Grupo: '2', estatus: 'pendiente' },
    { Curp: 'DUGJ960116em5', Nombre: 'Jorge Valdez Coronado', Grado: '3°', Grupo: '1', estatus: 'entregados' },
    { Curp: 'DUGJ960116em6', Nombre: 'Martin Valdez Coronado', Grado: '3°', Grupo: '1', estatus: 'devolucion' },
    { Curp: 'DUGJ960116em7', Nombre: 'Eduardo Coronado Campa', Grado: '2°', Grupo: '2', estatus: 'pendiente' },
    { Curp: 'DUGJ960116em8', Nombre: 'Omar Coronado Campa', Grado: '2°', Grupo: '1', estatus: 'entregados' },
];


let arr2 = [
    { Curp: 'DUGJ960116em0', folio: '0000000001 ', Grado: '2°', Grupo: '1', motivo: '', lote: '1-A', nserie: '000001',estatus: 'devolucion', evidencia: '' },
    { Curp: 'DUGJ960116em1', folio: '0000000002', Grado: '2°', Grupo: '1', motivo: '', lote: '1-A', nserie: '000001',estatus: 'devolucion', evidencia: '' },
    { Curp: 'DUGJ960116em2', folio: '0000000003', Grado: '1°', Grupo: '1', motivo: '', lote: '1-A', nserie: '000001', estatus: 'devolucion', evidencia: '' },
    { Curp: 'DUGJ960116em3', folio: '0000000004', Grado: '1°', Grupo: '2', motivo: '', lote: '1-A', nserie: '000001', estatus: 'entregados', evidencia: '' },
    { Curp: 'DUGJ960116em4', folio: '0000000005', Grado: '1°', Grupo: '2', motivo: 'no tiene cargador ', lote: '1-A', nserie: '000001', estatus: 'entregados', evidencia: '' },
    { Curp: 'DUGJ960116em5', folio: '0000000006', Grado: '3°', Grupo: '1', motivo: 'esta dañada de la pantalla ', lote: '1-A', nserie: '000001', estatus: 'entregados', evidencia: '' },
    { Curp: 'DUGJ960116em6', folio: '0000000007', Grado: '3°', Grupo: '1', motivo: '', lote: '1-A', nserie: '000001',estatus: 'entregados', evidencia: '' },
    { Curp: 'DUGJ960116em7', folio: '0000000008', Grado: '2°', Grupo: '2', motivo: '', lote: '1-A', nserie: '', estatus: 'entregados', evidencia: '' },
    { Curp: 'DUGJ960116em8', folio: '0000000009', Grado: '2°', Grupo: '1', motivo: 'no prende', lote: '1-B', nserie: '000001', estatus: 'entregados', evidencia: '' },
];

const statuses = [
    { label: 'A', value: '1' },
    { label: 'B', value: '2' },
];

const oficinas = [
    { label: 'R. Guaymas', value: 'R. Guaymas' },
    { label: 'R. Hermosillo', value: 'R. Hermosillo' },
    { label: 'R. Cajeme', value: 'R. Cajeme' }
];

let emptyArr = { Curp: null, Nombre: null, A_Paterno: '', A_Materno: '',folio: '', Grado: '', nserie:'', motivo: '', Grupo: null, estatus: '', evidencia:'' }

const DashboardDirector = () => {

    const [tablets, setTablets] = useState([]);
    const [lstBaseDatos, setLstBaseDatos] = useState([])
    const [tablet, setTablet] = useState(emptyArr);
    const [tabletDialog, setTabletDialog] = useState(false);
    const [tabletDialog2, setTabletDialog2] = useState(false);
    const [selectedTablets, setSelectedTablets] = useState([]);
    const toast = useRef(null)

    useEffect(() => {
        if (tablets.length === 0) {
            setTablets(arr);
        }
    }, [tablets]);

    useEffect(() => {
        if (tabletDialog === true && lstBaseDatos.length === 0) {
            setLstBaseDatos(arr2)
        }

    }, [tabletDialog, lstBaseDatos])


    useEffect(() => {
        if (tabletDialog2 === true && lstBaseDatos.length === 0) {
            setLstBaseDatos(arr2)
        }

    }, [tabletDialog2, lstBaseDatos])

    const hideDialog = () => {
        setTabletDialog(false);
    }

    const hideDialog2 = () => {
        setTabletDialog2(false);
    }

    const onRowEditComplete = (e) => {
        let _tablets = [...lstBaseDatos];
        let { newData, index } = e;

        _tablets[index] = newData;

        setLstBaseDatos(_tablets);
    }

    const openNew = () => {
        setTablet(emptyArr);
        setTabletDialog(true)
    }

    const openNew2 = () => {
        setTablet(emptyArr);
        setTabletDialog2(true)
    }

    const statusBodyTemplate = (rowData) => {
        let arr = {
            1: 'A',
            2: 'B'
        }
        return <span className={`product-badge status-${arr[parseInt(rowData.Grupo)].toLowerCase().replace(' ', '-')}`}>{arr[parseInt(rowData.Grupo)]}</span>;
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Asignar" icon="pi pi-plus" className="p-button" onClick={openNew} />
            </React.Fragment>
        )
    }

    const tabletDialogFooter = (
        <React.Fragment>
            <Button label="Confirmar" icon="pi pi-check" className="p-button" onClick={openNew2} />
            <Button label="Cancelar" icon="pi pi-times" className="p-button-outlined" onClick={hideDialog} />
        </React.Fragment>
    );
    const tabletDialogFooter2 = (
        <React.Fragment>
            <Button label="Guardar" icon="pi pi-check" className="p-button" onClick={() => ''} />
            <Button label="Cancelar" icon="pi pi-times" className="p-button-outlined" onClick={hideDialog} />
        </React.Fragment>
    );

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _tablet = { ...tablet };
        _tablet[`${name}`] = val;

        setTablet(_tablet);
    }

    const statusEditor = (options) => {
        return (
            <Dropdown value={options.value} options={statuses} optionLabel="label" optionValue="value"
                onChange={(e) => options.editorCallback(e.value)} placeholder="Grupo"
                itemTemplate={(option) => {
                    return <span className={`product-badge status-${option.value.toLowerCase()}`}>{option.label}</span>
                }} />
        );
    }

    const statusObservaciones = (options) => {
        return <InputText type='text' value={options.observaciones} onChange={(e) => options.editorCallback(e.target.value)} />
    }

    const statusRegional = (options) => {
        return (
            <Dropdown value={options.value} options={oficinas} optionLabel='label' optionValue='value'
                onChange={(e) => options.editorCallback(e.value)} placeholder='Of. Regional' />
        );
    }

    return (
        <>
            <Toast ref={toast} />
            <div className='grid'>
                <Menu link='filtro' />
                <div className='col-12'>
                    <Toolbar right={rightToolbarTemplate} />
                </div>
                <div className='col-12 p-4'>
                    <DataTable value={tablets}>
                        <Column field='Curp' header='Curp' />
                        <Column field='Nombre' header='Nombre Completo' />
                        <Column field='Grado' header='Grado' />
                        <Column field='Grupo' header='Grupo' body={statusBodyTemplate} style={{ minWidth: '12rem' }} />
                        <Column field='estatus' header='Estatus' />
                    </DataTable>
                </div>
            </div>
            <Dialog visible={tabletDialog} style={{ width: '90%' }} header="ASIGNACION DE TABLETA" modal className="p-fluid" footer={tabletDialogFooter} onHide={hideDialog}>
                <div className='grid'>
                    <div className='col-3'>
                        {/* <div className="p-field">
                            <div className="p-text-center">CURP: DUGJ960116em0</div>
                            <div className="p-text-center">FOLIO: 000001 </div>
                            <div className="p-text-center">SERIE: 000001</div>
                            <div className="p-text-center">ESTATUS: entregados</div>
                            <div className="p-text-center">MOTIVO: </div>
                        </div> */}
                    </div>
                    <div className='col-12 mt-6'>
                        <DataTable value={lstBaseDatos} TABLA DEL MODAL
                            selection={selectedTablets} onSelectionChange={e => setSelectedTablets(e.value)}
                            editMode='row' dataKey='Nombre' onRowEditComplete={onRowEditComplete}>
                            <Column selectionMode='multiple' headerStyle={{ width: '3em' }} />
                            <Column header='Curp' field='Curp' />
                            <Column header='Folio' field='folio' />
                            <Column header='Numero de Serie' field='nserie' editor={(options) => statusRegional(options)} />
                            <Column header='Estatus' field='estatus' />
                            <Column header='Motivo' field='motivo' editor={(options) => statusObservaciones(options)} />
                            <Column header='Evidencia' field='evidencia' />
                            <Column header='Grado' field='Grado' />
                            <Column header='Grupo' field='Grupo' body={statusBodyTemplate} editor={(options) => statusEditor(options)} />
                            <Column heder='Acción' rowEditor />
                        </DataTable>
                    </div>
                </div>
            </Dialog>

            <dialog visible={tabletDialog2} style={{ width: '60%' }} header="DETALLES DE TABLETAS" modal className="p-fluid" footer={tabletDialogFooter2} onHide={hideDialog2}>
                <div className='grid'>
                    <div className='col-3'>
                        <div className="p-field">
                            <div className="p-text-center">CURP: DUGJ960116em0</div>
                            <div className="p-text-center">FOLIO: 000001 </div>
                            <div className="p-text-center">SERIE: 000001</div>
                            <div className="p-text-center">ESTATUS: entregados</div>
                            <div className="p-text-center">MOTIVO: </div>
                        </div>
                    </div>
                </div>
            </dialog>
        </>
    );
}
export default DashboardDirector;
